import { render } from "./CreateTechnique.vue?vue&type=template&id=84fdd2dc&scoped=true"
import script from "./CreateTechnique.vue?vue&type=script&lang=js"
export * from "./CreateTechnique.vue?vue&type=script&lang=js"

import "./CreateTechnique.vue?vue&type=style&index=0&id=84fdd2dc&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fdd2dc"]])

export default __exports__